import {ListOfValue} from 'shared/models/ListOfValue';

export type ListOfValueStore = {
  lovs: Record<ListOfValue['type'], ListOfValue[]>;
};

export const initialState: ListOfValueStore = {
  lovs: {},
};
